import Vue from "vue";
import store from "./store/store.js";
import Router from "vue-router";
import Login from "./views/Login.vue";
import AdminLogin from "./views/AdminLogin"
import Register from "./views/Register.vue";
import Registered from "./views/Registered.vue";
import AccountConfirmation from "./views/AccountConfirmation.vue";
import UpdateProfile from "./views/UpdateProfile.vue";
import ResetPassword from "./views/ResetPassword.vue";
import ResetPasswordConfirmation from "./views/ResetPasswordConfirmation.vue";
import Feedback from "./views/Feedback.vue";
import Subscription from "./views/Subscription.vue";
import Inbox from "./views/Inbox.vue";
import DashboardAllProperties from "./views/DashboardAllProperties.vue";
import QRRedirect from "./components/utilities/QRRedirect.vue";
import AllIssues from "./views/AllIssues.vue";
import AssetsAndTeamOfProperty from "./views/AssetsAndTeamOfProperty.vue";
import PropertyTechAssetRestrictions from "./views/PropertyTechAssetRestrictions.vue";
import AssetsLogsAndIssues from "./views/AssetsLogsAndIssues.vue";
import UserAllAssetsTable from "./views/UserAllAssetsTable.vue";
import IssueReports from "./views/IssueReports.vue";
import PrintQrCodes from "./views/PrintQrCodes"
import ResendRegistrationConfirmationEmail from "./views/ResendRegistrationConfirmationEmail.vue";
import LogRocket from 'logrocket';
import Roles from "./views/Roles";
import newDesignTest from "./views/newDesignTest.vue";

let EntryURL = null;

Vue.use(Router);

const router = new Router({
  mode: "history",
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          resolve(savedPosition);
        }, 1000);
      });
    }
  },
  routes: [
    {
      path: "/",
      name: "Login",
      components: {
        default: Login,
      },
      beforeEnter: (to, from, next) => {
        if (Object.keys(store.state.user.user).length == 0) { 
          next();
        } else {
          next("/DashboardAllProperties");
        }
      },
      meta: {
        notAuth: true,
      },
    },
    {
      path: "/Login",
      name: "Login",
      props: true,
      components: {
        default: Login,
      },
      beforeEnter: (to, from, next) => {
        if (Object.keys(store.state.user.user).length == 0) { 
          next();
        } else {
              next("/DashboardAllProperties");
        }
      },
      meta: {
        notAuth: true,
      },
    },
    {
      path: "/AdminLogin",
      name: "AdminLogin",
      components: {
        default: AdminLogin,
      }
    },
    {
      path: "/ResetPassword",
      name: "ResetPassword",
      components: {
        default: ResetPassword,
      },
      meta: {
        notAuth: true,
      },
    },
    {
      path: "/ResetPasswordConfirmation*",
      name: "ResetPasswordConfirmation",
      components: {
        default: ResetPasswordConfirmation,
      },
    },
    {
      path: "/Register",
      name: "Register",
      components: {
        default: Register,
      },
      beforeEnter: (to, from, next) => {
        if (Object.keys(store.state.user.user).length == 0) { 
          next();
        } else {
          next("/DashboardAllProperties");
        }
      },
      meta: {
        notAuth: true,
      },
    },
    {
      path: "/Registered",
      name: "Registered",
      components: {
        default: Registered,
      },
    },
    {
      path: "/ResendRegisterEmail",
      name: "ResendRegisterEmail",
      components: {
        default: ResendRegistrationConfirmationEmail,
      },
    },
    {
      path: "/AccountConfirmation*",
      name: "AccountConfirmation",
      components: {
        default: AccountConfirmation,
      },
    },

    {
      path: "/DashboardAllProperties",
      name: "DashboardAllProperties",
      props: true,
      components: {
        default: DashboardAllProperties,
      },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/UpdateProfile",
      name: "UpdateProfile",
      components: {
        default: UpdateProfile,
      },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/Feedback",
      name: "Feedback",
      components: {
        default: Feedback,
      },
      meta: {
        notAuth: true,
      },
    },
    {
      path: "/Subscription",
      name: "Subscription",
      components: {
        default: Subscription,
      },
      meta: {
        notAuth: true,
      },
    },
    {
      path: "/Inbox",
      name: "Inbox",
      components: {
        default: Inbox,
      },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/AllIssues",
      name: "AllIssues",
      components: {
        default: AllIssues,
      },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/PropertybyId/:propertyid",
      props: true,
      component: AssetsAndTeamOfProperty,
      meta: {
        requiresAuth: true,
      },
    },

    {
      path: "/UsersAssets",
      props: true,
      name: "UsersAssets",
      component: UserAllAssetsTable,
      meta: {
        requiresAuth: true,
      },
    },

    {
      path: "/WorkOrderReports",
      name: "WorkOrderReports",
      component: IssueReports,
      meta: {
        requiresAuth: true,
      },
    },

    {
      path: "/MachinebyId/:MachineId",
      name: "MachinewithId",
      props: true,
      components: {
        default: AssetsLogsAndIssues,
      },
      meta: {
        requiresAuth: true,
      },
    },
    {
      path: "/TechRestrictions/:TechUserId",
      name: "TechRestrictions",
      props: true,
      components: {
        default: PropertyTechAssetRestrictions,
      },
      meta: {
        requiresAuth: true,
      },
    },

    {
      path: "/qr/:id",
      name: "qrredirect",
      components: {
        default: QRRedirect,
      },
      meta: {
        requiresAuth: true,
      },
    },
    {
     path: "/printqrcodes",
      name: "printqrcodes",
      components: {
        default: PrintQrCodes,
      },
      meta: {
        requiresAuth: true,
      },
    },
 
     {
      path: "/Roles",
       name: "Roles",
       components: {
         default: Roles,
       },
       meta: {
         requiresAuth: true,
       },
     },

     {
      path: "/newdesigntest",
       name: "newdesigntest",
       components: {
         default: newDesignTest,
       },
       meta: {
         requiresAuth: true,
       },
     },
  ],
});
router.beforeEach((to, from, next) => {
  // //clear page title
 // store.dispatch("clearTitle");

  
  // $.connection.hub.stop(function () {
  // });

  //if user is logged in save to log rocket
if(store.state.user.user.userid){
    LogRocket.identify(store.state.user.user.userid, {
        name: store.state.user.user.firstname + " " + store.state.user.user.lastname,
        email: store.state.user.user.userName,
    // Add your own custom user variables here, ie:
    subscriptionType: 'pro'
    });
  }
  //save current route for back button.

  //but don't save when user scans Qr code, since the back button will direct you to the last page which
  // automatically redirects to the current page, so it always stays at the same page
  if(!to.path.includes("/qr/")){

    //if a link contains hashtag dispatch the link without hash, but for other url query pararmeters dispatch full url
    if(to.fullPath.includes("#")){
      store.dispatch("addRoute", to.path);
    } else {
  store.dispatch("addRoute", to.fullPath);
    }
  }
  // if navigating to login page allow through. this avoids vue router infinity loop of sending to login if not logged in
  console.log(
    "to.path is " +
      to.path +
      "and substrin 0 3 is " +
      to.path.substr(0, 4) +
      "and the path to /qr/ is equal to "
  );
  console.log(to.path.substr(0, 4) == "/qr/");
  
  if (to.path == "/login" || to.path.substr(0, 4) == "/qr/") {
    next();
  }

  // is user logged in?
  let userFromLocalStorage = store.state.user.user;
  if (Object.keys(store.state.user.user).length == 0) { 
    console.log("user is not logged in");

    if (to.matched.some((record) => record.meta.requiresAuth) &&  Object.keys(store.state.user.user).length == 0) {
      console.log(
        "not logged in user trying to access require auth path of" + to.path
      );
      EntryURL = to.fullPath;
      console.log("pushing to /Login");

      next("/Login");
    } else {
      console.log("not logged in user navigating to public path of" + to.path);

      next();
    }
  } else {
    console.log("user is logged in");

    //is user token valid?

    const expdate = new Date(userFromLocalStorage[".expires"]);
    const currentdate = new Date();

    
    if (expdate.getTime() < currentdate.getTime()) {

      EntryURL = to.path;
      var refreshToken = userFromLocalStorage.refresh_token;
      store.state.user.user = {};
      store.dispatch("refreshTokenAutomatic", refreshToken).then ( () => {
        const url = EntryURL;
        EntryURL = null;
        next(url);
      })
     
    } else {

      if (Object.keys(store.state.user.user).length > 0 && EntryURL) {
        const url = EntryURL;
        EntryURL = null;
        next(url);
      }

      if (to.matched.some((record) => record.meta.notAuth) && Object.keys(store.state.user.user).length > 0) {
        console.log(
          "user is logged in and navigating to non auth route of" + to.path
        );
        next();
      }
      next();
    }
  }

  // if (userFromLocalStorage) {
  //   const testloggedin = JSON.parse(userFromLocalStorage);
  //   console.log(testloggedin[".expires"]);
  //   const expdate = new Date(testloggedin[".expires"]);
  //   const currentdate = new Date();
  //   if (expdate.getTime() > currentdate.getTime()) {
  //     console.log("token expired");
  //     localStorage.clear();
  //   } else {
  //     console.log(
  //       "token is current" +
  //         expdate +
  //         "< exp date this is the current " +
  //         currentdate
  //     );
  //   }
  // }
});
router.afterEach((to, from) => {});
// const scrollBehavior = function(to, from, savedPosition) {
//   // savedPosition is only available for popstate navigations.
//   return { x: 0, y: 5000 };
// };
export default router;
